module.exports = "/images/6bd4b97bd204e18898d10a45a0c1efbd.svg";